import { Navigate } from 'react-router-dom';

const CMSRoute = ({ children }) => {
    const userRole = sessionStorage.getItem("userRoleType");
    // console.log("userRole", userRole);

    if (userRole === "cms_user") {
        const allowedRoutes = ["/home-cms", "/content-list", "/forgetPassword", "/resetPassword", "/login", "/past-session"];
        // console.log("window.location.pathname",window.location.pathname)
        // console.log("window.location.children",children)

        if (!allowedRoutes.includes(window.location.pathname)) {
            // console.log("Redirecting to /home-cms");
            return <Navigate to="/home-cms" />;
        } else {
            // console.log("Rendering children for CMS user",children);
            return children;
        }
    } else if (userRole === "cms_admin") {
        // console.log("Rendering children for Admin user");
        return children;
    } else {
        // console.log("Redirecting to /login");
        return <Navigate to="/login" />;
    }
};

export default CMSRoute;
